export const billingDashboardData = {
  mrrUsd: 142000,
  arrUsd: 1704000,
  outstandingUsd: 28400,
  failedPayments: 4,
  revenueTrend12m: [
    { month: '2024-04', value: 118000 },
    { month: '2024-05', value: 120500 },
    { month: '2024-06', value: 122800 },
    { month: '2024-07', value: 125200 },
    { month: '2024-08', value: 127900 },
    { month: '2024-09', value: 129400 },
    { month: '2024-10', value: 131200 },
    { month: '2024-11', value: 133800 },
    { month: '2024-12', value: 136500 },
    { month: '2025-01', value: 138200 },
    { month: '2025-02', value: 140100 },
    { month: '2025-03', value: 142000 },
  ],
  invoiceAging: [
    { bucket: 'Current', amountUsd: 82000 },
    { bucket: '1-30 days', amountUsd: 12400 },
    { bucket: '31-60 days', amountUsd: 9100 },
    { bucket: '60+ days', amountUsd: 4900 },
  ],
  overdueTenants: Array.from({ length: 8 }, (_, i) => ({
    id: `od-${i}`,
    companyName: `Overdue Co ${i + 1}`,
    plan: ['Starter', 'Growth', 'Enterprise'][i % 3],
    invoiceNumber: `INV-${13000 + i}`,
    amountUsd: 2400 + i * 300,
    dueDate: new Date(Date.now() - (15 + i * 12) * 86400000).toISOString(),
    daysOverdue: 15 + i * 12,
    tenantId: `tnt-${3000 + i}`,
  })),
};

export const invoicesList = Array.from({ length: 35 }, (_, i) => {
  const st = ['paid', 'pending', 'overdue', 'failed'][i % 4];
  const due = new Date(Date.now() - i * 86400000 + 86400000 * (st === 'overdue' ? -10 : 14));
  return {
    id: `inv-${12000 + i}`,
    invoiceNumber: `INV-${12000 + i}`,
    tenantId: `tnt-${3100 + (i % 18)}`,
    tenantCode: `MH-${String(3000 + (i % 20)).padStart(4, '0')}`,
    companyName: `Invoice Customer ${i + 1}`,
    amountUsd: 899 + i * 120,
    status: st === 'pending' ? 'pending' : st,
    issuedAt: new Date(Date.now() - i * 86400000 - 86400000 * 5).toISOString(),
    dueAt: due.toISOString(),
    lineItems: [
      { desc: 'Platform subscription', qty: 1, unitUsd: 799, totalUsd: 799 },
      { desc: 'Add-on: AI minutes', qty: 10, unitUsd: 10, totalUsd: 100 },
    ],
    taxUsd: 0,
    totalUsd: 899 + i * 120,
    paymentHistory: [
      { at: new Date(Date.now() - i * 86400000).toISOString(), status: st === 'failed' ? 'failed' : 'attempted', detail: 'Stripe' },
    ],
    paymentNotes: '',
  };
});

export const paymentIssues = Array.from({ length: 12 }, (_, i) => ({
  id: `pay-${i}`,
  tenantId: `tnt-${4000 + i}`,
  tenantCode: `MH-${String(4000 + i).padStart(4, '0')}`,
  companyName: `Payment Issue ${i + 1}`,
  issueType: ['card_declined', 'insufficient_funds', 'expired_card', 'processor_timeout'][i % 4],
  amountUsd: 1200 + i * 200,
  attemptedOn: new Date(Date.now() - i * 3600000).toISOString(),
  status: ['open', 'retrying', 'waived'][i % 3],
  owner: `finops${i % 3}@meetinghub.ai`,
  nextStep: i % 2 === 0 ? 'Contact tenant for new card' : 'Retry after 24h',
}));
